import script from "./employee-job-life.vue?vue&type=script&lang=ts&setup=true"
export * from "./employee-job-life.vue?vue&type=script&lang=ts&setup=true"

import "./employee-job-life.vue?vue&type=style&index=0&id=c6863a64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6863a64"]])

export default __exports__